<template minapp='mpx' xlang='wxml'>
  <view class="entrance" bindtap="click" wx:class="{{ {'entrance-margin': needMargin}}}">
    <view class="title">
      <image class="train" src="{{trainIconUrl}}"></image>
      {{ title }}
    </view>
    <view class="button">
      {{ button }}
      <image class="arrow" src="{{arrowIconUrl}}"></image>
    </view>
  </view>
  <es-riskmanagement tickets12306="{{!needLogin12306}}" />
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import { requestHomeOrderListApi } from '@/api/home'
  import store from '@/store'
  import { innerRouter, pagePath, getCurrentOrigin } from '@/common/jump'
  import { goTo } from '@didi/webx-js'

  createComponent({
    props: {
      needMargin: {
        type: Boolean,
        value: false
      }
    },
    pageLifetimes: {
      hide: function () {
        this.showVerification && this.setShowVerification(false)
      }
    },
    data() {
      return {
        trainIconUrl: 'https://dpubstatic.udache.com/static/dpubimg/dHJRrCKnrEG7nfSFPB8mU.png',
        arrowIconUrl: 'https://dpubstatic.udache.com/static/dpubimg/YymluDTOJZxVKZJC7AO48.png'
      }
    },
    computed: {
      ...store.mapState({
        userInfo12306: 'login12306.userInfo12306',
        userAccountList: 'login12306.userAccountList',
        showVerification: 'tickets12306.showVerification',
        needLogin12306: 'tickets12306.needLogin12306'
      }),
      account() {
        return this.userInfo12306?.account_with_star
      },
      title() {
        return this.account || '登录12306，查看本人车票'
      },
      button() {
        return this.account ? '查看本人车票' : '去登录'
      }
    },
    methods: {
      ...store.mapActions({
        get12306TicketsAction: 'tickets12306.get12306TicketsAction'
      }),
      ...store.mapMutations({
        setShowVerification: 'tickets12306.setShowVerification'
      }),
      async click() {
        if (this.account) {
          // 已登录，请求本人车票接口
          this.get12306TicketsAction()
        } else {
          // 未登录，跳转12306登录
          innerRouter.replace(pagePath().LOGIN12306, {from: 'tickets12306'})
          // const url = getCurrentOrigin() + pagePath().LOGIN12306
          // goTo({url})
        }
      }
    }
  })
</script>

<style lang='stylus' scoped>
  .entrance
    display flex
    background #FFFFFF
    border-radius 8px
    margin 15px 0 2.5px 0px
    padding 10px 14px
    align-items center
    justify-content space-between
    font-family PingFang SC
    &-margin
      margin 15px 10px 0 10px
    .title
      display flex
      align-items center
      color #333333
      font-weight 600
      font-size 16px
    .train
      width 16px
      height 18px
      margin-right 5px
    .button
      color #999999
      font-size 14px
      display flex
      align-items center
    .arrow
      width 4.5px
      height 8px
      margin-left 4.5px
</style>

<script name='json'>
  module.exports = {
    usingComponents: {
      'es-riskmanagement': '@/pages/login12306/components/rm/risk-management'
    }
  }
</script>
